module.exports = __webpack_public_path__ + "img/facebook-icon.310e57a.png";